<template>
  <!-- 下载页 -->
  <div class="download-container">
      <home-nav>
        <div class="top-banner_wrapper" slot="topbanner">
          <div class="text-content">果师兄恢复大师工程师团队由近30位经验丰富的专业技术人员组成，为苹果设备用户提供相关周边服务，以及相关的数据迁移和数据删除等指导服务。
          </div>
        </div>
      </home-nav>
      <download-item :downloadinfo="m_guoshixiong_download" :text="downloadText"></download-item>
      <div class="service-steps_header">服务流程介绍</div>
      <ul class="service-steps_container">
        <li class="steps-item" v-for="(step,index) in steps" :key="index" >
          <div class="content" v-if="index%2 == 0">
             <img class="steps-intro steps-pic" :src="step.pic" :alt="step.header"/>
              <section class="steps-intro steps-description">
                <p class="steps-header">
                  {{step.header}}
                </p>
                <p class="steps-sub-description">
                  {{step.description}}
                </p>
                <div class="steps-pointing" v-show="index != steps.length-1">
                  <img src="../assets/images/m_download_dashed1@3x.png"  :alt="step.header" >
                </div>
              </section>
          </div>
          <div class="content" v-else>
              <section class="steps-intro steps-description">
                <p class="steps-header">
                  {{step.header}}
                </p>
                <p class="steps-sub-description" v-html="step.description">
                </p>
               <div class="steps-pointing">
                  <img src="../assets/images/m_download_dashed2@3x.png"  :alt="step.header" v-show="index != steps.length-1">
                </div>
              </section>
             <img class="steps-intro steps-pic" :src="step.pic" :alt="step.header" />
          </div>
        </li>
      </ul>
      <copyright-footer></copyright-footer>
      <Footer_></Footer_>
  </div>

</template>

<script>
import Footer_ from './Footer.vue';

export default {
  metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
  },
  data(){
    return{
     steps: [
        {
          header:'选择服务',
          description:'选择您需要的服务类型',
          pic:require("../assets/images/m_global_flow_step1@3x.png")
        },
        {
          header:'选择套餐',
          description:'选择您需要预约的套餐',
          pic:require("../assets/images/m_global_flow_step2@3x.png")

        },
        {
          header:'提交订单',
          description:'提交订单，支付预约工程师的人力费',
          pic:require("../assets/images/m_global_flow_step3@3x.png")

        },
        {
          header:'工程师接单',
          description:'工程师主动联系您，确认服务时间',
          pic:require("../assets/images/m_global_flow_step4@3x.png")

        },
        {
          header:'工程师鉴定',
          description:'工程师提供操作服务，并告知操作进度',
          pic:require("../assets/images/m_global_flow_step5@3x.png")

        },
        {
          header:'确认方案',
          description:'您确认对服务内容和效果是否满足要求，<br/>并决定是否支付服务尾款',
          pic:require("../assets/images/m_global_flow_step6@3x.png")

        }
        ,
        {
          header:'支付尾款',
          description:'您支付尾款后，工程师协助完成剩余操作',
          pic:require("../assets/images/m_global_flow_step7@3x.png")

        },
        {
          header:'完成服务',
          description:'您确认服务已完成，完成订单和评价',
          pic:require("../assets/images/m_global_flow_step8@3x.png")

        }
      ],
      m_guoshixiong_download: {
        download_channel: "m.gsx.download",
        download_channel_name: "下载页-立即下载",
      },
      downloadText:'专家一对一贴心服务'

    }
  },
  components:{
    Footer_
  }

}
</script>

<style lang="scss">
  @import '../assets/css/base.scss';
  .download-container{

  
   .service-steps_header{
    font-size: pxtorem(18px);
    color:rgba(26,26,26,1);
    padding:0 0 pxtorem(18px);
    text-align: center;
  }
  .service-steps_container{
    padding:pxtorem(9px) pxtorem(20px)  pxtorem(30px);
    border-bottom:pxtorem(2px) solid rgba(237,237,237,1);
   
    .steps-item{
      position: relative;
      .content{
        display: flex;
      }
      .steps-pointing{
        position: absolute;
        bottom:px2vw(10px);
        left:px2vw(100px);
        img{
          width: px2vw(198px);
        }
      }
      &:nth-child(even){
        text-align: right;
        .steps-pointing{
          position: absolute;
          bottom:px2vw(10px);
          left:px2vw(41px);
          img{
            width: px2vw(198px);
          }
        }
      }
      .steps-pic{
        height:px2vw(99px);
        flex-shrink: 0;
        box-shadow: 0px 8px 4px -6px rgba(49,98,250,.5);
        margin-top:pxtorem(-9px);
        
      }
    
      .steps-intro+.steps-intro{
        margin-left:pxtorem(16px);
      }
      .steps-description{
        color:rgba(89,89,89,1);
        flex: 1;
        padding-top:px2vw(12px);
        .steps-header{
          font-size:pxtorem(14px);
          font-weight: bold;
        } 
      }
      .steps-sub-description{
          font-size:pxtorem(12px);
          padding-top:pxtorem(5px);
          line-height: pxtorem(18px);

      }
    }
    
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/Download.vue